<script setup lang="ts">
import { onMounted, ref } from 'vue';

const isVisible = ref<boolean>(false);

onMounted(() => {
  isVisible.value = true;
});
</script>

<template>
  <transition mode="out-in" name="smooth-appear">
    <slot v-if="isVisible" />
  </transition>
</template>

<style scoped lang="scss">
.smooth-appear-enter-active,
.smooth-appear-leave-active {
  transition: all var(--transition-short);
}
.smooth-appear-enter-from,
.smooth-appear-leave-to {
  opacity: 0;
}
</style>
